module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_shinjuku-aa1c70d1cab6cf1e7a7a499dffd561a7.jpg";